import { RefObject, useEffect } from 'react'

export const useSearchInputKeyboardNavigation = (ref: RefObject<HTMLElement>) => {
  // Focus the search input when the user presses Cmd/Ctrl + K
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const isMac = navigator.userAgent.includes('Mac')
      const shortCutPressed =
        (isMac && e.metaKey && e.key === 'k') || (!isMac && e.ctrlKey && e.key === 'k')

      if (shortCutPressed) {
        e.preventDefault()
        ref.current?.focus()
      }
    }

    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [ref])
}
